
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Main from "./app/index";
import { Worker } from '@react-pdf-viewer/core';
import { useSelector } from "react-redux";
import Login from "./app/pages/Login";
import ForgetPassword from "./app/pages/ForgetPassword";
import ResetPassword from "./app/pages/ResetPassword";
import OuterHtml from "./app/components/OutterHtml";
import Home from "./app/pages/Home";
import PublicRoute from "./app/PublicRoute";
import PrivateRoute from "./app/PrivateRoute";
import { Suspense } from "react";
import Diagnosis from "./app/pages/Diagnosis";
import PatientResults from "./app/pages/PatientResults";
import AllergiesHome from "./app/pages/AllergiesHome";
import ImmuneHome from "./app/pages/ImmuneHome";
import TimelineHome from "./app/pages/TimelineHome";
import RemidersHome from "./app/pages/RemidersHome";
import ResourcesHome from "./app/pages/ResourcesHome";
import LettersDocs from "./app/pages/LettersDocs";
import ServiceTemplate from "./app/pages/ServiceTemplate";
import Vitals from "./app/pages/Vitals";
import UserProfile from "./app/pages/UserProfile";
import MyCareTeam from "./app/pages/MyCareTeam";
import ReadMessage from "./app/components/ReadMessage";
import Messaing from "./app/pages/Messaing";
import Med from "./app/pages/Med";
import MainContainer from "./app/components/MainContainer";
import Appointments from "./app/pages/Appointments";
import { StateProvider } from "./app/components/StateContext";
import UpdatePassword from "./app/pages/UpdatePassword";
function App() {
  const { TokenValidator, isChecking, error } = useSelector(
    (state) => state.validateToken
  );
  return (
    <StateProvider>
    <Worker workerUrl="https://unpkg.com/pdfjs-dist@2.6.347/build/pdf.worker.min.js">
     <BrowserRouter>
     <Routes>
            <Route path="/login" element= {<Login/>}   />
            <Route path="/forgetPassword" element={<ForgetPassword />} />
            <Route path="/updatepassword" element={<UpdatePassword />} />
            <Route path="/resetpassword" element={<ResetPassword />} />
            <Route path="/" element={<PrivateRoute />}>
            <Route path="/" element={
              // <Suspense fallback={<SuspenseFallback />}>
              <MainContainer>
                  <Home />
                  </MainContainer>
              // </Suspense>
            }
            />
            <Route path="/appointments" element={ <MainContainer><Appointments/></MainContainer>} />
            <Route path="/diagnosis" element={<MainContainer><Diagnosis/></MainContainer>} />
            <Route path="/medications" element={<MainContainer><Med /></MainContainer>} />
            <Route path="/reports" element={<MainContainer><PatientResults /></MainContainer>} />
            <Route path="/allergies" element={<MainContainer><AllergiesHome /></MainContainer>} />
            <Route path="/immunisation" element={<MainContainer><ImmuneHome /></MainContainer>} />
            <Route path="/timeline" element={<MainContainer><TimelineHome /></MainContainer>} />
            <Route path="/reminders" element={<MainContainer><RemidersHome /></MainContainer>} />
            <Route path="/resources" element={<MainContainer><ResourcesHome /></MainContainer>} />
            <Route path="/letters" element={<MainContainer><LettersDocs /></MainContainer>} />
            <Route path="/servicetemplate" element={<MainContainer><ServiceTemplate /></MainContainer>} />
            <Route path="/vitals" element={<MainContainer><Vitals /></MainContainer>} />
            <Route path="/emails" element={<MainContainer><Messaing /></MainContainer>} />
            <Route path="/profile" element={<MainContainer><UserProfile /></MainContainer>} />
            <Route path="/myCareTeam" element={<MainContainer><MyCareTeam /></MainContainer>} />
            <Route path="/read" element={<MainContainer><ReadMessage /></MainContainer>} />
            </Route>
            
            {/* <Route path="/preview" element={<PrivateRoute component={OuterHtml} authed={TokenValidator} />} /> */}
            {/* <Route path="/" element={<PrivateRoute component={Home} authed={TokenValidator} />} /> */}
            {/* <Route path="/appointments" element={<PrivateRoute component={Appointments} authed={TokenValidator} />} />
            <Route path="/diagnosis" element={<PrivateRoute component={Diagnosis} authed={TokenValidator} />} />
            <Route path="/medications" element={<PrivateRoute component={Med} authed={TokenValidator} />} />
            <Route path="/reports" element={<PrivateRoute component={PatientResults} authed={TokenValidator} />} />
            <Route path="/allergies" element={<PrivateRoute component={AllergiesHome} authed={TokenValidator} />} />
            <Route path="/immunisation" element={<PrivateRoute component={ImmuneHome} authed={TokenValidator} />} />
            <Route path="/timeline" element={<PrivateRoute component={TimelineHome} authed={TokenValidator} />} />
            <Route path="/reminders" element={<PrivateRoute component={RemidersHome} authed={TokenValidator} />} />
            <Route path="/resources" element={<PrivateRoute component={ResourcesHome} authed={TokenValidator} />} />
            <Route path="/letters" element={<PrivateRoute component={LettersDocs} authed={TokenValidator} />} />
            <Route path="/servicetemplate" element={<PrivateRoute component={ServiceTemplate} authed={TokenValidator} />} />
            <Route path="/vitals" element={<PrivateRoute component={Vitals} authed={TokenValidator} />} />
            <Route path="/emails" element={<PrivateRoute component={Messaing} authed={TokenValidator} />} />
            <Route path="/profile" element={<PrivateRoute component={UserProfile} authed={TokenValidator} />} />
            <Route path="/myCareTeam" element={<PrivateRoute component={MyCareTeam} authed={TokenValidator} />} />
            <Route path="/read" element={<PrivateRoute component={ReadMessage} authed={TokenValidator} />} /> */}
          </Routes>
        {/* <Main /> */}
        </BrowserRouter> 
    </Worker>
    </StateProvider>

  );
}

export default App;
